/**
 * Registration & Discovery Errors (AJIP-16.02.005 · WS12)
 * ---------------------------------------------------------------------
 * 13 typed subclasses of JourneyError.
 */
import { JourneyError } from '../core/JourneyErrors';

class RegistrationError extends JourneyError {}
class InvalidJourneyDefinitionError extends RegistrationError {}
class DuplicateJourneyIdError extends RegistrationError {}
class InvalidJourneyVersionError extends RegistrationError {}
class UnknownFeatureFlagError extends RegistrationError {}
class InvalidClassificationError extends RegistrationError {}
class InvalidDiscoveryContextError extends RegistrationError {}
class PermissionEvaluationFailureError extends RegistrationError {}
class EligibilityFailureError extends RegistrationError {}
class RegistrationConflictError extends RegistrationError {}
class UnsupportedVersionError extends RegistrationError {}
class DeprecatedJourneyError extends RegistrationError {}
class MissingPrerequisiteError extends RegistrationError {}
class ProtectedComponentViolationError extends RegistrationError {}

const REGISTRATION_DISCOVERY_ERROR_TYPES = Object.freeze([
  'RegistrationError',
  'InvalidJourneyDefinitionError', 'DuplicateJourneyIdError', 'InvalidJourneyVersionError',
  'UnknownFeatureFlagError', 'InvalidClassificationError', 'InvalidDiscoveryContextError',
  'PermissionEvaluationFailureError', 'EligibilityFailureError', 'RegistrationConflictError',
  'UnsupportedVersionError', 'DeprecatedJourneyError', 'MissingPrerequisiteError',
  'ProtectedComponentViolationError',
]);

export {
  RegistrationError,
  InvalidJourneyDefinitionError, DuplicateJourneyIdError, InvalidJourneyVersionError,
  UnknownFeatureFlagError, InvalidClassificationError, InvalidDiscoveryContextError,
  PermissionEvaluationFailureError, EligibilityFailureError, RegistrationConflictError,
  UnsupportedVersionError, DeprecatedJourneyError, MissingPrerequisiteError,
  ProtectedComponentViolationError,
  REGISTRATION_DISCOVERY_ERROR_TYPES,
};
